<template>
  <div class="digitalzone-detail">
    <div style="display: flex; align-items: center; margin-bottom: 10px">
      <span>终端服务人员：{{ userName }}</span>
      <span style="margin-left: 10px">任务时间：</span>
      <BaseSelect
        v-if="monthList.length > 0"
        v-model="month"
        @change="onChangeMonth"
        style="width: 200px"
        :options="monthList"
      ></BaseSelect>
    </div>
    <BaseTable :columns="columns" :data="tableData"></BaseTable>
  </div>
</template>

<script lang="tsx" setup>
import { ref, computed } from 'vue';
import {
  BaseTable,
  BaseSelect,
  BaseTableProps,
  useTableColumn
} from 'xrk-components';
import { selectMonthTask, taskRecordDetail } from '../data-source/apis';

const props = withDefaults(
  defineProps<{
    projectId: number;
    projectType: number;
    id: number;
    dataState: number;
  }>(),
  {
    projectId: null,
    projectType: null,
    id: null
  }
);
const month = ref(null);
const tableData = ref([]);
const titleList = ref([]);

const userName = ref('');
const monthList = ref([]);

const onChangeMonth = async () => {
  const { data } = await selectMonthTask({
    userId: userId.value,
    projectId: props.projectId,
    month: month.value
  });

  // 处理 uvList 数据
  const uvList = data.uvList;
  const tableDataList = [];
  uvList.forEach(item => {
    const tableRow = {};
    item.forEach(citem => {
      tableRow[citem.date] = citem.uv;
    });
    tableDataList.push(tableRow);
  });
  // 生成表头
  titleList.value = data.titleList;
  // 生成表格数据
  tableData.value = tableDataList;
};

const userId = ref(null);
const getData = async () => {
  const { data: detail } = await taskRecordDetail({
    sceneType: props.projectType,
    id: props.id,
    dataState: props.dataState,
    projectId: props.projectId
  });
  userName.value = detail.username;
  monthList.value = detail.monthList.map(item => {
    return {
      value: item,
      label: item
    };
  });
  month.value = monthList.value[0].value;
  userId.value = detail.userId;
  onChangeMonth();
};

const columns = computed<BaseTableProps['columns']>(() => {
  return titleList.value.map(item => {
    return useTableColumn({
      label: item,
      prop: item
    });
  });
});

getData();
</script>

<style lang="scss">
.digitalzone-detail {
  padding: 20px;
}
</style>
